import styled from "styled-components";

export const HeaderTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  & > * {
    text-align: center;
  }
`;

export const BodyContentWrapper = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  & > * {
    text-align: center;
  }
`;

export const ActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme?.spacing?.md ?? "12px"};
`;
